/* globals wordpress_globals */
// import '../styles/fonts.scss';
import '../styles/theme.scss';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import convertDataAttributesToObject from '@global/convertDataAttributesToObejct';
import asyncSVG from '@global/asyncSVG';
import { loadIcons } from '@global/SVGSprite';

import { moduleDefinition } from './modules';

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    // Gammy fix so that the child SVG is ahead of the parent one so that the child SVG gets used when the same ID exists.
    setTimeout(() => {
      asyncSVG.load('./wp-content/themes/class/dist/sprite.svg');
    }, 10);

    this.asyncModules(moduleDefinition);

    document.querySelector('[href="#cookie-preferences"]')?.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();

      document.querySelector<HTMLElement>('.wcc-btn-revisit')?.click();
    });
  },
  asyncModules: function (modules: ModuleDefinition[]) {
    (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
      (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
        const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
        const args = { ...defaultArgs, ...formattedArgs };

        return import(`./modules/${moduleName}.ts`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      });
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  bootstrap.init();
});

// SVG Sprite Loader
loadIcons(require.context('@project/assets/icons', true, /\.svg$/));
